import { z } from "zod";
import { Id, IsoDateTime, Money } from "./common.ts";

/** `Order` lifecycle. Spec-locked to _spec-backbone.md §4. */
export const OrderStatus = z.enum([
  "pending",
  "accepted",
  "preparing",
  "ready",
  "served",
  "cancelled",
  "rejected",
]);
export type OrderStatus = z.infer<typeof OrderStatus>;

export const OrderLine = z.object({
  menuItemId: Id,
  name: z.string().min(1),
  quantity: z.number().int().positive(),
  unitPrice: Money,
  note: z.string().optional(),
});
export type OrderLine = z.infer<typeof OrderLine>;

export const Order = z.object({
  id: Id,
  sessionId: Id,
  tableId: Id,
  customerId: Id.optional(),
  status: OrderStatus,
  lines: z.array(OrderLine).min(1),
  total: Money,
  note: z.string().optional(),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
});
export type Order = z.infer<typeof Order>;

export const CreateOrder = z.object({
  tableId: Id,
  lines: z
    .array(
      z.object({
        menuItemId: Id,
        quantity: z.number().int().positive(),
        note: z.string().optional(),
      }),
    )
    .min(1),
  note: z.string().optional(),
});
export type CreateOrder = z.infer<typeof CreateOrder>;
